import {
  createContext,
  useCallback,
  useContext,
  type ReactNode
} from "react";
import { noop } from "lodash";

import { useDispatch } from "react-redux";

import { toggleModalState } from "../containers/App/App.slice";

interface ModalContextType {
  open: (id: string) => void;
  close: (id: string) => void;
}

export const ModalContext = createContext<ModalContextType>({
  open: noop,
  close: noop
});

export const ModalContextProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();

  const open = useCallback(
    (id: string) => dispatch(toggleModalState(id, true)),
    [ dispatch ]
  );

  const close = useCallback(
    (id: string) => dispatch(toggleModalState(id, false)),
    [ dispatch ]
  );

  return (
    <ModalContext.Provider
      value={{
        open,
        close
      }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === null) {
    throw new Error(
      "useModal must be used within a ModalContextProvider"
    );
  }
  return context;
};
